import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AUTHENTICATION_SERVICE_TOKEN,
  USER_ROLE_SERVICE_TOKEN,
} from '@aksia/infrastructure';

@Component({
  standalone: true,
  selector: 'app-dummy',
  imports: [CommonModule],
  template: `
    <div class="auth-page">
      <h1>Dummy Protected Page</h1>
      @if (user.activeUser()) {
        <p>Hello, {{ user.activeUser()?.userName }}</p>
      }
      @if (!user.activeUser()) {
        <p>You are not signed in.</p>
      }
      <button (click)="signOut()">Sign out</button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyPageContent {
  protected readonly user = inject(USER_ROLE_SERVICE_TOKEN);
  private readonly auth = inject(AUTHENTICATION_SERVICE_TOKEN);

  protected signOut() {
    this.auth.signOut?.();
  }
}
